import classNames from "classnames";
import { Button } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";

import styles from "@/components/chip/UserChip.module.scss";

interface IUserChipProps {
  label: string;
}

function UserChip({ label }: IUserChipProps) {
  return (
    <Button
      variant="link"
      className={classNames(
        "rounded-5 text-primary bg-primary-subtle d-inline-flex align-items-center gap-1 text-decoration-none",
        styles.chip
      )}
    >
      <PersonCircle />
      <span>{label}</span>
    </Button>
  );
}

export default UserChip;
